import React, { useState } from 'react'
import { Popover, PopoverBody } from 'reactstrap'
import { BsThreeDots } from 'react-icons/bs'
import { BiFolder } from 'react-icons/bi'
import ReactTooltip from 'react-tooltip'
import {
  LayoutRowLines,
  LayoutDataLines,
} from '../../../components/TableComponents/RowCardShadow/RowCardShadow'
import { formatItemCount } from './folderService'

// A folder as a row INSIDE the compact mobile Lines table. Mobile survey rows are
// split across two parallel <Col>s, so this renders ONE half per call:
//   half="name" -> left Name Col (peach icon + name + count, opens the folder)
//   half="data" -> right scrollable Col (a dash per data column + 3-dots actions)
// Callers invoke it once in each Col's map, iterating sortedFolders in the same order.
const FolderRowMobileLines = ({
  half,
  folder,
  itemCount,
  itemNoun,
  isAdmin,
  dataColWidths,
  actionColWidth,
  onOpen,
  onRename,
  onDelete,
}) => {
  const [menuOpen, setMenuOpen] = useState(false)

  if (half === 'name') {
    return (
      <LayoutRowLines className={'planning-row-mobile-height mx-0 px-0'}>
        <LayoutDataLines colWidth={12} noFlex>
          <div
            className="d-flex folder-row-name-col folder-row-mobile-lines-name cursor-pointer"
            onClick={() => {
              if (onOpen) {
                onOpen()
              }
            }}
            data-tip={folder.name}>
            <div className="folder-row-icon-wrap">
              <BiFolder className="folder-row-icon" />
            </div>
            <div className="folder-row-mobile-text">
              <span className="survey-item-title d-block">{folder.name}</span>
              <span className="folder-row-count">
                {formatItemCount(itemCount, itemNoun)}
              </span>
            </div>
          </div>
          <ReactTooltip />
        </LayoutDataLines>
      </LayoutRowLines>
    )
  }

  const blanks = dataColWidths || []
  const popoverId = `folderListRowMobile_${folder._id}`
  return (
    <LayoutRowLines className="pl-tasks-row row-scroll-width-s">
      {blanks.map((width, idx) => (
        <LayoutDataLines key={idx} colWidth={width} className="text-center">
          <span className="list-empty-dash">&mdash;</span>
        </LayoutDataLines>
      ))}
      <LayoutDataLines colWidth={actionColWidth} className="text-center">
        {isAdmin ? (
          <div className="cursor-pointer">
            <span
              id={popoverId}
              className="cursor-pointer"
              onClick={() => setMenuOpen(true)}>
              <BsThreeDots />
            </span>
            <Popover
              isOpen={menuOpen}
              target={popoverId}
              toggle={() => setMenuOpen(false)}
              placement="bottom"
              modifiers={{
                flip: { boundariesElement: 'viewport' },
                preventOverflow: { boundariesElement: 'viewport' },
              }}
              hideArrow
              className="surveyListRow_Popover">
              <PopoverBody>
                <div
                  className="dropdown-item my-1 cursor-pointer"
                  onClick={() => {
                    setMenuOpen(false)
                    if (onOpen) {
                      onOpen()
                    }
                  }}>
                  Open folder
                </div>
                <div
                  className="dropdown-item my-1 cursor-pointer"
                  onClick={() => {
                    setMenuOpen(false)
                    if (onRename) {
                      onRename(folder)
                    }
                  }}>
                  Rename folder
                </div>
                <div
                  className="dropdown-item my-1 cursor-pointer folder-menu-item-delete"
                  onClick={() => {
                    setMenuOpen(false)
                    if (onDelete) {
                      onDelete(folder)
                    }
                  }}>
                  Delete folder
                </div>
              </PopoverBody>
            </Popover>
          </div>
        ) : null}
      </LayoutDataLines>
    </LayoutRowLines>
  )
}

export default FolderRowMobileLines
